export default "__VITE_ASSET__15df6c3f__"